import React from 'react';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default function Excel({children, data, filename='data-exported-file.xlsx'}) {
  const ws = XLSX.utils.json_to_sheet(data?.Data || []);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, data?.Name || "Sheet1");

  const excelBuffer = XLSX.write(wb, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  return (
      <span onClick={() => saveAs(blob, filename)}>
        {children}
      </span>
  );
};
